import gql from 'graphql-tag';

import { executeGqlMutation } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';
import type {
  BackendMutationDeleteSavedDocumentTextRatingArgs,
  BackendSavedDocumentTextRating,
} from 'src/types/backend';

const MUTATION = gql`
  mutation DeleteSavedDocumentTextRating($id: ID!) {
    deleteSavedDocumentTextRating(id: $id) {
      id
    }
  }
`;

type Variables = BackendMutationDeleteSavedDocumentTextRatingArgs;
type Result = Pick<BackendSavedDocumentTextRating, 'id'>;

export const deleteSavedDocumentTextRating = async (variables: Variables) => {
  const result = await executeGqlMutation({ mutation: MUTATION, variables });
  return getSingleProp<Result>(result.data);
};
